$("#shopify-section-header").remove();
    var typed = new Typed('.auto-type', {
    strings: [
      "Pharmacy",
      "Health Food",
      "Kids Boutique",
      "Outdoor",
      "Camping",
      "Specialty",
      "Resorts & Accommodation",
      "Medical & Allied Health",
      "Sporting",
      "Outdoor Activities"
    ],
    typeSpeed: 60,
    backDelay: 1000,
    loop: true,
    loopCount: Infinity
  });
  
 $(document).ready(function () { 
    $("#to-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 500);
    });

    $(".hash-down a, .hash-link").on("click", function (t) {
        if ("" !== this.hashUrl) {
            t.preventDefault();
            var o = this.hash;
            
            $("html, body").animate({ scrollTop: $(o).offset().top - 78 }, 100, function () {
                window.location.hashUrl = o;
            });
        }
    });

    $('.testimonials').slick({
        infinite: true,
        slidesToShow: 1,
        dots: true,
        mobileFirst: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick'
            }
        ]
    });

    function showHideVendorForm(){
        $('.vendor-button-container').hide(); 
        $('.vendor-application-container').show();
    }
    $('.btn-show-vendor').click(function(e){
        e.preventDefault();
        showHideVendorForm()
    });
    $('.sign-up').click(function(e){ 
        showHideVendorForm()
    });
});

// const menu = document.querySelector('#menuBtn')
// const menuList = document.querySelector('#menuList')


// function toggleMenu() {
//     menuList.classList.toggle('active')
//     menuList.parentElement.classList.toggle('active')

//     if (menuList.classList.contains('active')) {
//     menu.setAttribute('src', "//www.natpat.com/cdn/shop/files/b2b-lp-cancel_1024x1024.png?v=10639980496394642577")
        
//     } else {
//     menu.setAttribute('src', '//www.natpat.com/cdn/shop/files/b2b-lp-menu_1024x1024.png?v=820358011764627298')
        
//     }
// }

//  menu.addEventListener('click', toggleMenu)
